import React from 'react';
import { View } from 'react-native';
import FileDownSvg from '@assets/images/svg/file-down.svg';

export interface FileDownIconProps {
    size?: number;
    color?: string;
}

export function FileDownIcon({ size = 18, color = '#1A1A1A' }: FileDownIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <FileDownSvg width={size} height={size} color={color} />
        </View>
    );
}
